import React from 'react';
import {
  Grid,
  Box,
  Skeleton,
  DialogActions,
} from '@mui/material';

const InsightDetailsSkeleton: React.FC = () => {
  return (
    <>
      <Box sx={{ px: 3, pt: 3 }}>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={12} md={8}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Skeleton variant="text" width="60%" height={40} />
              <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
            </Box>
          </Grid>
          <Grid item xs={6} md={2}>
            <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
          </Grid>
          <Grid item xs={6} md={2}>
            <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 1 }} />
          </Grid>
        </Grid>
        <Grid container spacing={1} mt={2}>
          <Grid item>
            <Skeleton variant="rectangular" width={120} height={28} sx={{ borderRadius: 3 }} />
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={80} height={28} />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ paddingLeft: '21px', pr: 3, paddingTop: 1, paddingBottom: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sx={{ px: '0 !important', marginTop: 2 }}>
            <Skeleton variant="text" width={120} height={32} />
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
              <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
            </Box>
          </Grid>
          <Grid item xs={12} mt={3} sx={{ p: '0 !important' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, padding: 1, justifyContent: 'space-between' }}>
              <Skeleton variant="text" width={120} height={32} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 1, mt: 1 }} />
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box>
                  <Skeleton variant="text" width={80} height={32} sx={{ mb: 1 }} />
                  <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 1 }} />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box>
                  <Skeleton variant="text" width={100} height={32} sx={{ mb: 1 }} />
                  <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 1 }} />
                </Box>
                <Box>
                  <Skeleton variant="text" width={100} height={32} sx={{ mb: 1 }} />
                  <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1 }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Grid container>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 1 }} />
            </Box>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};

export default InsightDetailsSkeleton;

